// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.logout-align {
  width: 100%;
  text-align: left;
  padding-left: 0;
  margin-left: 0;
  border-radius: 0;
}

.fa-md {
  font-size: 1.25em;
}

/* ---------------------------------- */
/* GLOBAL/BODY STYLES (LIMPIO)        */
/* ---------------------------------- */
body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background-color: transparent;
  min-height: 100vh;
}

/* ---------------------------------- */
/* BACKGROUND WRAPPER (Contiene el color base y el fondo con forma) */
/* ---------------------------------- */
.background-gradient {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.background-gradient::before {
  overflow: hidden;
}

/* ---------------------------------- */
/* FONDO CON DEGRADADO SUAVE VERTICAL */
/* ---------------------------------- */
.background-gradient::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  /* Altura del degradado, limitada a unos 400px o más, según tu diseño */
  height: 400px;
  width: 100%;
  /* Degradado lineal de arriba (color) a abajo (transparente) */
  background: linear-gradient(to bottom, rgba(0, 9, 81, 0.4) 0%, rgba(0, 9, 81, 0.3) 30%, transparent 100%);
  /* IMPORTANTE: Eliminamos cualquier clip-path o mask-image anterior */
  mask-image: none;
  pointer-events: none;
  z-index: 0;
}

/* ---------------------------------- */
/* LOGO STYLES (Gmatik)               */
/* ---------------------------------- */
.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 800;
  font-size: 1.5rem;
  color: #000;
  text-decoration: none;
}

.logo-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, #ff6b6b 0deg, #ffa500 60deg, #32cd32 120deg, #00bcd4 180deg, #3f51b5 240deg, #9c27b0 300deg, #ff6b6b 360deg);
  position: relative;
}

.logo-icon::before {
  content: "";
  position: absolute;
  inset: 4px;
  background: #fff;
  border-radius: 50%;
}

.logo-icon::after {
  content: "G";
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  color: #3f51b5;
  font-family: Arial, sans-serif;
}

/* ---------------------------------- */
/* HEADER LAYOUT                      */
/* ---------------------------------- */
.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: calc(100vw - 200px);
  margin: 0 auto;
  background-color: transparent;
  z-index: 100;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease, box-shadow 0.3s ease;
  position: sticky !important;
  top: 10px !important;
  min-height: 64px;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-right {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.header.scrolled {
  top: 0px !important;
  background-color: rgba(0, 9, 81, 0.1);
  padding-left: 20px;
  padding-right: 20px;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(200, 200, 200, 0.3);
  /* Elimina padding-top y padding-bottom para evitar cambio de altura */
  padding-top: 0;
  padding-bottom: 0;
}
.header.scrolled .menu-navigation-container {
  background-color: #fff;
  backdrop-filter: none;
}

/* ---------------------------------- */
/* CONTENT LAYOUT (AdminBar, Grid)    */
/* ---------------------------------- */
#admin-content {
  padding: 24px;
  padding-top: 24px;
}

.cointainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cointainer-bt {
  margin-bottom: 10px;
}

.active {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/scss/global.scss","webpack://./src/scss/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;ACTA,uCAAA;AACA,uCAAA;AACA,uCAAA;AAEA;EACE,SAAA;EACA,UAAA;EACA,8BAAA;EACA,6BAAA;EACA,iBAAA;ADWF;;ACRA,uCAAA;AACA,qEAAA;AACA,uCAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;ADUF;;ACPA;EACE,gBAAA;ADUF;;ACRA,uCAAA;AACA,uCAAA;AACA,uCAAA;AAEA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EAEA,uEAAA;EACA,aAAA;EACA,WAAA;EAEA,8DAAA;EACA,yGACE;EASF,qEAAA;EAEA,gBAAA;EAEA,oBAAA;EACA,UAAA;ADFF;;ACKA,uCAAA;AACA,uCAAA;AACA,uCAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;ADHF;;ACMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kJAAA;EAUA,kBAAA;ADZF;;ACeA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;ADZF;;ACeA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;ADZF;;ACgBA,uCAAA;AACA,uCAAA;AACA,uCAAA;AACA;EACE,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,8BAAA;EACA,cAAA;EAEA,6BAAA;EACA,YAAA;EAEA,uFACE;EAIF,2BAAA;EACA,oBAAA;EAEA,gBAAA;EACA,sBAAA;ADvBF;;AC0BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ADvBF;;AC0BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ADvBF;;AC2BA;EACE,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,iDAAA;EACA,sEAAA;EACA,cAAA;EACA,iBAAA;ADxBF;AC0BE;EACE,sBAAA;EACA,qBAAA;ADxBJ;;AC4BA,uCAAA;AACA,uCAAA;AACA,uCAAA;AAEA;EACE,aAAA;EACA,iBAAA;AD1BF;;AC6BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AD1BF;;AC6BA;EACE,mBAAA;AD1BF;;AArJA;EACE,UAAA;AAwJF","sourcesContent":["// Alineación para el botón de cerrar sesión en el menú de usuario\n.logout-align {\n  width: 100%;\n  text-align: left;\n  padding-left: 0;\n  margin-left: 0;\n  border-radius: 0;\n}\n// Tamaño intermedio para iconos FontAwesome\n.fa-md {\n  font-size: 1.25em;\n}\n@import \"./index.scss\";\n\n.active {\n  color: red;\n}\n","@import \"./colors.scss\";\n\n/* ---------------------------------- */\n/* GLOBAL/BODY STYLES (LIMPIO)        */\n/* ---------------------------------- */\n\nbody {\n  margin: 0; \n  padding: 0;\n  font-family: Arial, sans-serif;\n  background-color: transparent; \n  min-height: 100vh;\n}\n\n/* ---------------------------------- */\n/* BACKGROUND WRAPPER (Contiene el color base y el fondo con forma) */\n/* ---------------------------------- */\n\n.background-gradient {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n}\n\n.background-gradient::before {\n  overflow: hidden;\n}\n/* ---------------------------------- */\n/* FONDO CON DEGRADADO SUAVE VERTICAL */\n/* ---------------------------------- */\n\n.background-gradient::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0; \n  \n  /* Altura del degradado, limitada a unos 400px o más, según tu diseño */\n  height: 400px; \n  width: 100%;\n  \n  /* Degradado lineal de arriba (color) a abajo (transparente) */\n  background: \n    linear-gradient(\n        to bottom, /* Dirección: de arriba hacia abajo */\n        /* Color fuerte en la parte superior (0%) */\n        rgba(0, 9, 81, 0.4) 0%, /* Naranja sutil */\n        rgba(0, 9, 81, 0.3) 30%,  /* Rosa sutil */\n        /* El color se desvanece y es completamente transparente al 100% de la altura */\n        transparent 100% \n    );\n  \n  /* IMPORTANTE: Eliminamos cualquier clip-path o mask-image anterior */\n  -webkit-mask-image: none;\n  mask-image: none;\n  \n  pointer-events: none;\n  z-index: 0; \n}\n\n/* ---------------------------------- */\n/* LOGO STYLES (Gmatik)               */\n/* ---------------------------------- */\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 800;\n  font-size: 1.5rem;\n  color: #000;\n  text-decoration: none;\n}\n\n.logo-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: conic-gradient(\n    from 0deg,\n    #ff6b6b 0deg,\n    #ffa500 60deg,\n    #32cd32 120deg,\n    #00bcd4 180deg,\n    #3f51b5 240deg,\n    #9c27b0 300deg,\n    #ff6b6b 360deg\n  );\n  position: relative;\n}\n\n.logo-icon::before {\n  content: \"\";\n  position: absolute;\n  inset: 4px;\n  background: #fff;\n  border-radius: 50%;\n}\n\n.logo-icon::after {\n  content: \"G\";\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 14px;\n  color: #3f51b5;\n  font-family: Arial, sans-serif;\n}\n\n\n/* ---------------------------------- */\n/* HEADER LAYOUT                      */\n/* ---------------------------------- */\n.header {\n  position: relative; // Para centrar MenuHeaderLeft absolutamente respecto al header\n  // height: 60px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  max-width: calc(100vw - 200px);\n  margin: 0 auto;\n\n  background-color: transparent;\n  z-index: 100;\n\n  transition: \n    background-color 0.3s ease,\n    backdrop-filter 0.3s ease,\n    box-shadow 0.3s ease;\n  \n  position: sticky !important;\n  top: 10px !important;\n\n  min-height: 64px; // Fija la altura mínima del header\n  box-sizing: border-box; // Incluye padding en el tamaño total\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px; \n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n\n.header.scrolled {\n  top: 0px !important;\n  background-color: rgba(0, 9, 81, 0.1);\n  padding-left: 20px;\n  padding-right: 20px;\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(200, 200, 200, 0.3);\n  /* Elimina padding-top y padding-bottom para evitar cambio de altura */\n  padding-top: 0;\n  padding-bottom: 0;\n\n  .menu-navigation-container {\n    background-color: #fff;\n    backdrop-filter: none; // Sin efecto cristal en scroll\n  }\n}\n\n/* ---------------------------------- */\n/* CONTENT LAYOUT (AdminBar, Grid)    */\n/* ---------------------------------- */\n\n#admin-content {\n  padding: 24px;\n  padding-top: 24px; \n}\n\n.cointainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cointainer-bt {\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
